var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { faCircleExclamation, faFileDownload, } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Inline } from "syf-component-library/ui/spacing";
import { Small } from "syf-component-library/ui/typography";
import { useQueryClient } from "@tanstack/react-query";
import { useStatementsContext } from "../../../context/statementsContext";
import { useConfig } from "../../../hooks/useConfig";
import { ErrorMessageWrapper, PDFButton, StatementSmallCaption, TokenErrorMessage, } from "../subcomponents";
import useStatementPdfMutation from "../../../hooks/useStatementPdfMutation";
import endPoints from "../../../const/endpoints";
import useNavigateToStatement from "../../../hooks/useNavigateToStatement";
import { getClickAnalyticsProperties } from "../../../const/analytics";
var PdfButton = function (_a) {
    var _b, _c, _d, _e;
    var statementsData = _a.statementsData, pdfType = _a.pdfType;
    var mfeConfig = useConfig();
    var accountId = useStatementsContext().state.accountId;
    var t = useTranslation().t;
    var queryClient = useQueryClient();
    var errorCount = useRef(0);
    var _f = useStatementPdfMutation({ errorCount: errorCount }), requestPdf = _f.mutate, isLoading = _f.isLoading, isError = _f.isError;
    var statementDate = (_b = statementsData.statementDate) !== null && _b !== void 0 ? _b : "";
    var isInsertButton = pdfType === "insert";
    var statementInsert = isInsertButton && Boolean((_c = statementsData === null || statementsData === void 0 ? void 0 : statementsData.statementDetails) === null || _c === void 0 ? void 0 : _c.statementInsert)
        ? (_d = statementsData === null || statementsData === void 0 ? void 0 : statementsData.statementDetails) === null || _d === void 0 ? void 0 : _d.statementInsert
        : undefined;
    var shouldDisableButtonClick = isLoading;
    var cachedBlob = queryClient.getQueryData([
        endPoints.statementsUrl,
        {
            accountId: accountId,
            statementDate: statementDate,
            statementInsert: statementInsert,
        },
    ]);
    var navigateToStatement = useNavigateToStatement();
    var pdfButtonClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!cachedBlob) {
                requestPdf({
                    mfeConfig: mfeConfig,
                    accountId: accountId,
                    statementDate: statementDate,
                    statementInsert: statementInsert,
                });
            }
            else if (cachedBlob) {
                navigateToStatement({ statementDate: statementDate, statementInsert: statementInsert });
            }
            return [2 /*return*/];
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsxs(PDFButton, __assign({ buttonType: "text", onClick: pdfButtonClick, disabled: shouldDisableButtonClick }, getClickAnalyticsProperties({
                reason: isInsertButton ? "insert" : "download",
            }), { children: [_jsx(FontAwesomeIcon, { icon: faFileDownload }), _jsx(Inline, { size: "small" }), _jsx("span", { children: isInsertButton
                            ? t("modal.table.insert")
                            : t("modal.table.statement") })] })), _jsxs(StatementSmallCaption, { children: [!isInsertButton && ((_e = statementsData.statementDetails) === null || _e === void 0 ? void 0 : _e.changeInTerms) && (_jsx(Small, { children: t("modal.table.changeOfTerms") })), isError && (_jsx(ErrorMessageWrapper, { children: _jsxs(TokenErrorMessage, { children: [_jsx(FontAwesomeIcon, { icon: faCircleExclamation }), _jsx(Inline, { size: "xsmall" }), isInsertButton
                                    ? t("modal.table.insertError")
                                    : t("modal.table.tokenError")] }) }))] })] }));
};
export default PdfButton;
